import React from 'react';
import { Box, Container, CssBaseline, Stack, Grid, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import PageHeading from '../../global/header/PageHeading';
import { useTranslation } from 'react-i18next';
// import { useTranslation } from 'react-i18next';
// import { t } from 'i18next';

const ThanksPage = () => {
  const { t } = useTranslation();
  return (
    <>
      <PageHeading pageTitle="Thank you" />
      <Container maxWidth="lg" className="selfRegistrationContainer">
        <Box textAlign="center">
          <Box>
            <Grid container spacing={{ xs: 1, sm: 2, md: 3 }} justifyContent="center">
              <Grid item xs={12} sm={6} md={5}>
                <Box mb={3} className="thanksMsgBox">
                  {/* <Typography variant="h6">{t('Thank you for registering')}</Typography> */}
                  <Typography variant="h6">{t('Thank you for registering')}</Typography>
                  <Typography variant="h6">
                    {t('Your eKYC is successfully submitted, and review in progress')}
                  </Typography>
                </Box>
              </Grid>
            </Grid>
            <Box Container justifyContent="center" alignItems="center">
              <Link to="/in/selfregistration" className="mainBtn btnLink" mb={2}>
                {t('Return to main menu')}
              </Link>
              <Link to="/in/video-kyc" className="mainBtn btnLink">
                {t('Continue for video KYC')}
              </Link>
              {/* <Link to="/in/video-kyc" className="mainBtn btnLink">
                Go to schedule for video KYC
              </Link> */}
            </Box>
          </Box>
        </Box>
      </Container>
    </>
  );
};

export default ThanksPage;
